import { render, staticRenderFns } from "./ContentCounters.vue?vue&type=template&id=b97d96bc&scoped=true&"
import script from "./ContentCounters.vue?vue&type=script&lang=js&"
export * from "./ContentCounters.vue?vue&type=script&lang=js&"
import style0 from "./ContentCounters.vue?vue&type=style&index=0&id=b97d96bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97d96bc",
  null
  
)

export default component.exports